import { AbstractControl, ValidatorFn } from '@angular/forms';
import { genderOptions } from 'src/configs/dropdown-options/options.nl';

export function genderValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        try {
            const gender = control.value.toLowerCase();
            for (let option of Object.values(genderOptions)) {
                if (gender === option.value) return null;
            }
        } catch { }
        return { genderInvalid: true };
    };
}